import { NavLink } from 'react-router-dom';
import { Activity, BarChart2, CalendarRange, Book } from 'lucide-react';
import { cn } from '@/lib/utils';

const ARC_TABS = [
  { to: '/arc/events',    label: 'Centro ARC',   icon: Activity },
  { to: '/arc/dashboard', label: 'Dashboard',     icon: BarChart2 },
  { to: '/arc/history',   label: 'Historial',     icon: CalendarRange },
  { to: '/arc/cid-codes', label: 'Códigos CID',   icon: Book },
] as const;

interface ArcSubNavProps {
  className?: string;
}

export function ArcSubNav({ className }: ArcSubNavProps) {
  return (
    <nav
      className={cn(
        'flex items-center gap-1 mb-5 border-b border-border pb-0',
        className,
      )}
    >
      {ARC_TABS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end
          className={({ isActive }: { isActive: boolean }) =>
            cn(
              'flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px',
              isActive
                ? 'border-amber-500 text-amber-500'
                : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
            )
          }
        >
          <Icon className="h-4 w-4" />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
